<template>
  <div class="assw-wizard">
    <ul class="step-indicator" v-if="!submitted">
      <li :class="{ completed: step >= 1 }"></li>
      <li :class="{ completed: step >= 2 }"></li>
      <li :class="{ completed: step >= 3 }"></li>
    </ul>
    <VoucherCounter
      v-if="(step === 2 || step === 3) && freeSamples >= 0"
      :voucherNumber="voucherNumber"
      :freeSamples="freeSamples"
      :totalSamples="totalSamples"
    ></VoucherCounter>
    <div class="step-container" v-if="!loading && !submitted">
      <VoucherInformation
        :class="{ visible: step === 1 }"
        ref="step1"
        @change="onChange"
        @setVoucherCounter="setVoucherCounter"
      >
      </VoucherInformation>
      <ContactInformation
        :class="{ visible: step === 2 }"
        ref="step2"
        @change="onChange"
      ></ContactInformation>
      <Installations
        :class="{ visible: step === 3 }"
        ref="step3"
        @change="onChange"
        :freeSamples="freeSamples"
      ></Installations>
    </div>
    <div class="loader" v-if="loading"></div>
    <div class="confirmation" v-if="submitted">
      <div>{{ labels.confirmation }}</div>
      <div>{{ labels.confirmation2 }}</div>
      <ul>
        <li v-for="i in confirmations" :key="i.id">
          <a @click="downloadConfirmation(i)"
            >{{ i.id }} - {{ i.name }} - {{ i.location }}</a
          >
        </li>
      </ul>
    </div>
    <div
      class="button-container"
      v-if="!loading"
      :class="{ singleButton: step === 1 }"
    >
      <FlatButton
        :label="labels.startOver"
        white
        inline-left
        v-if="submitted"
        @click="reset"
      ></FlatButton>
      <FlatButton
        :label="labels.prev"
        white
        inline-left
        v-if="step !== 1 && !submitted"
        @click="gotoPrevStep"
      ></FlatButton>
      <FlatButton
        :label="labels.next"
        blue
        inline-right
        v-if="step !== 3 && !submitted"
        @click="gotoNextStep"
      ></FlatButton>
      <FlatButton
        :label="labels.submit"
        blue
        inline-right
        v-if="step === 3 && !submitted"
        @click="onSubmit"
      ></FlatButton>
    </div>
  </div>
</template>

<script>
import { FlatButton } from "clariant-vue3-forms";
import ContactInformation from "./ContactInformation.vue";
import Installations from "./Installations.vue";
import ExtraInformation from "./ExtraInformation.vue";
import VoucherInformation from "./VoucherInformation.vue";
import VoucherCounter from "./VoucherCounter.vue";
import { DataLayer, Labels, State, Utils, Config } from "../services.js";
import { NetworkHelper } from "clariant-helpers-vue3";

export default {
  name: "wizard",
  components: {
    FlatButton,
    ContactInformation,
    Installations,
    ExtraInformation,
    VoucherInformation,
    VoucherCounter,
  },
  data() {
    return {
      step: 1,
      labels: Labels,
      loading: false,
      submitted: false,
      state: State,
      voucherIsValid: false,
      voucherNumber: "",
      freeSamples: 0,
      totalSamples: 0,
      confirmations: [],
    };
  },
  mounted() {},
  methods: {
    gotoNextStep() {
      if (this.step >= 3) return;
      if (this.validateCurrentStep()) {
        this.step++;
      }
    },
    gotoPrevStep() {
      if (this.step === 1) return;
      this.step--;
    },
    onChange() {},
    setVoucherCounter(voucherData) {
      this.voucherNumber = voucherData.voucherNumber;
      this.freeSamples = voucherData.freeSamples;
      this.totalSamples = voucherData.totalSamples;
      State.distributor = voucherData.distributor;
      State.voucherNumber = voucherData.voucherNumber;
    },
    validateCurrentStep() {
      let step = null;
      switch (this.step) {
        case 1:
          step = this.$refs.step1;
          break;
        case 2:
          step = this.$refs.step2;
          break;
        case 3:
          step = this.$refs.step3;
          break;
        case 3:
          step = this.$refs.step4;
          break;
        default:
          break;
      }
      if (step) return step.validateStep();
      else return false;
    },
    onSubmit() {
      if (!this.$refs.step1.validateStep()) {
        this.step = 1;
        return;
      }
      if (!this.$refs.step2.validateStep()) {
        this.step = 2;
        return;
      }
      if (!this.$refs.step3.validateStep()) {
        return;
      }
      this.confirmations = [];
      this.loading = true;
      let self = this;
      DataLayer.submitRequest()
        .then(({ data }) => {
          self.submitted = true;
          self.freeSamples -= State.installations.length;
          self.confirmations = data.map((x) => {
            return { id: x.id, name: x.name, location: x.location };
          });
          State.save();
          this.reportToAnalytics();
        })
        .catch((err) => {
          let msg = err.response?.data?.Message || err.message || err;
          if (msg?.indexOf("enough") !== -1) self.freeSamples = -1;//hack so we don't have to make another request
          Utils.showStatusMessage(msg, "red");
        })
        .finally(() => {
          self.loading = false;
        });
    },
    reset() {
      this.submitted = false;
      this.step = 1;
      State.reset();
    },
    downloadConfirmation(installation) {
      if (!installation) return;
      let url = NetworkHelper.signUrl(
        `${Config.wsUrl}/downloadSampleConfirmation?id=${installation.id}`
      );
      window.open(url, "_blank");
    },
    reportToAnalytics() {
      if (!cla || !cla.component || !cla.component.analytics) return;
        console.log(`Submitting Antifrogen Samples wizard submission event to analytics.`);
        cla.component.analytics.submitCustomEvent("Custom form submitted", {
            formName: "Antifrogen Samples Submission Wizard"
        });
    }
  },
};
</script>

<style>
.assw-wizard {
  outline: 1px solid #d4d4d4;
  box-sizing: border-box;
  padding: 20px;
  display: flex;
  flex-direction: column;
}

.step-indicator {
  width: 100%;
  display: flex;
  flex-direction: row;
  list-style: none;
  justify-content: space-between;
}

.step-indicator li {
  width: 32%;
  height: 10px;
  outline: 1px solid #3da9f6;
  background-color: white;
}

.step-indicator li.completed {
  background-color: #3da9f6;
}

.step-container {
  flex-grow: 1;
}

.step-container > .step {
  display: none;
  padding: 20px 0;
}

.step-container > .step.visible {
  display: flex;
}

.step-container > .step > .form {
  height: 100%;
  width: 100%;
}

.step-container > .step > .form > .form-title {
  font-weight: 500;
  font-size: 22px;
}

.step-container > .step > .form > .form-fields {
  display: flex;
  flex-direction: column;
  align-items: space-between;
  justify-content: center;
  width: 100%;
}

.row {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.row.col-1 > .col {
  width: 100%;
}

.row.col-2 > .col {
  width: 47%;
}

.loader {
  align-self: center;
  min-height: 400px;
  background-repeat: no-repeat;
  background-position: 50%;
  width: 64px;
  height: 64px;
  background-image: url("data:image/svg+xml;charset=utf8,%3Csvg class='lds-spinner' width='64px' height='64px' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 100 100' preserveAspectRatio='xMidYMid' style='background: none;'%3E%3Cg transform='rotate(0 50 50)'%3E%3Crect x='47' y='24' rx='9.4' ry='4.8' width='6' height='12' fill='%233498DB'%3E%3Canimate attributeName='opacity' values='1;0' keyTimes='0;1' dur='1s' begin='-0.9166666666666666s' repeatCount='indefinite'%3E%3C/animate%3E%3C/rect%3E%3C/g%3E%3Cg transform='rotate(30 50 50)'%3E%3Crect x='47' y='24' rx='9.4' ry='4.8' width='6' height='12' fill='%233498DB'%3E%3Canimate attributeName='opacity' values='1;0' keyTimes='0;1' dur='1s' begin='-0.8333333333333334s' repeatCount='indefinite'%3E%3C/animate%3E%3C/rect%3E%3C/g%3E%3Cg transform='rotate(60 50 50)'%3E%3Crect x='47' y='24' rx='9.4' ry='4.8' width='6' height='12' fill='%233498DB'%3E%3Canimate attributeName='opacity' values='1;0' keyTimes='0;1' dur='1s' begin='-0.75s' repeatCount='indefinite'%3E%3C/animate%3E%3C/rect%3E%3C/g%3E%3Cg transform='rotate(90 50 50)'%3E%3Crect x='47' y='24' rx='9.4' ry='4.8' width='6' height='12' fill='%233498DB'%3E%3Canimate attributeName='opacity' values='1;0' keyTimes='0;1' dur='1s' begin='-0.6666666666666666s' repeatCount='indefinite'%3E%3C/animate%3E%3C/rect%3E%3C/g%3E%3Cg transform='rotate(120 50 50)'%3E%3Crect x='47' y='24' rx='9.4' ry='4.8' width='6' height='12' fill='%233498DB'%3E%3Canimate attributeName='opacity' values='1;0' keyTimes='0;1' dur='1s' begin='-0.5833333333333334s' repeatCount='indefinite'%3E%3C/animate%3E%3C/rect%3E%3C/g%3E%3Cg transform='rotate(150 50 50)'%3E%3Crect x='47' y='24' rx='9.4' ry='4.8' width='6' height='12' fill='%233498DB'%3E%3Canimate attributeName='opacity' values='1;0' keyTimes='0;1' dur='1s' begin='-0.5s' repeatCount='indefinite'%3E%3C/animate%3E%3C/rect%3E%3C/g%3E%3Cg transform='rotate(180 50 50)'%3E%3Crect x='47' y='24' rx='9.4' ry='4.8' width='6' height='12' fill='%233498DB'%3E%3Canimate attributeName='opacity' values='1;0' keyTimes='0;1' dur='1s' begin='-0.4166666666666667s' repeatCount='indefinite'%3E%3C/animate%3E%3C/rect%3E%3C/g%3E%3Cg transform='rotate(210 50 50)'%3E%3Crect x='47' y='24' rx='9.4' ry='4.8' width='6' height='12' fill='%233498DB'%3E%3Canimate attributeName='opacity' values='1;0' keyTimes='0;1' dur='1s' begin='-0.3333333333333333s' repeatCount='indefinite'%3E%3C/animate%3E%3C/rect%3E%3C/g%3E%3Cg transform='rotate(240 50 50)'%3E%3Crect x='47' y='24' rx='9.4' ry='4.8' width='6' height='12' fill='%233498DB'%3E%3Canimate attributeName='opacity' values='1;0' keyTimes='0;1' dur='1s' begin='-0.25s' repeatCount='indefinite'%3E%3C/animate%3E%3C/rect%3E%3C/g%3E%3Cg transform='rotate(270 50 50)'%3E%3Crect x='47' y='24' rx='9.4' ry='4.8' width='6' height='12' fill='%233498DB'%3E%3Canimate attributeName='opacity' values='1;0' keyTimes='0;1' dur='1s' begin='-0.16666666666666666s' repeatCount='indefinite'%3E%3C/animate%3E%3C/rect%3E%3C/g%3E%3Cg transform='rotate(300 50 50)'%3E%3Crect x='47' y='24' rx='9.4' ry='4.8' width='6' height='12' fill='%233498DB'%3E%3Canimate attributeName='opacity' values='1;0' keyTimes='0;1' dur='1s' begin='-0.08333333333333333s' repeatCount='indefinite'%3E%3C/animate%3E%3C/rect%3E%3C/g%3E%3Cg transform='rotate(330 50 50)'%3E%3Crect x='47' y='24' rx='9.4' ry='4.8' width='6' height='12' fill='%233498DB'%3E%3Canimate attributeName='opacity' values='1;0' keyTimes='0;1' dur='1s' begin='0s' repeatCount='indefinite'%3E%3C/animate%3E%3C/rect%3E%3C/g%3E%3C/svg%3E");
}

.confirmation {
  display: flex;
  flex-direction: column;
  justify-content: center;
  justify-self: stretch;
  flex-grow: 1;
  align-items: center;
  min-height: 400px;
}

.confirmation div {
  font-size: 24px;
  line-height: normal;
  font-weight: 500;
}

.confirmation a {
  cursor: pointer;
}

.confirmation ul {
  margin-top: 20px;
}

.button-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.button-container.singleButton {
  justify-content: flex-end;
}

@media all and (max-width: 600px) {
  .button-container {
    display: flex;
    flex-direction: column-reverse;
  }

  .inline-left,
  .inline-right {
    float: unset;
    margin: 0;
  }

  .row {
    flex-direction: column;
  }

  .row.col-2 > .col {
    width: 100%;
  }

  .checklabel {
    font-size: 12px !important;
  }
}
</style>
